import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-tracciati-field-regole',
    templateUrl: './tracciati-field-regole.component.html',
    styleUrls: ['./tracciati-field-regole.component.scss'],
    standalone: false
})
export class TracciatiFieldRegoleComponent implements OnChanges {
  @Input() set rulesString(value: string) {
    this._rulesString = value;
    this.loadRulesFromString(value);
  }
  @Output() rulesStringChange = new EventEmitter<string>();
  form: FormGroup;
  serializedRules: string = '';
  private _rulesString: string = '';

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      rules: this.fb.array([])
    });
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['rulesString'] && changes['rulesString'].currentValue !== this.serializedRules) {
      this.loadRulesFromString(this._rulesString);
    }
  }
  
  get rules(): FormArray {
    return this.form.get('rules') as FormArray;
  }
  addRule(pattern: string = '', replacement: string = '') {
    const group = this.fb.group({
      pattern: [pattern, Validators.required],
      replacement: [replacement, Validators.required]
    });
    this.rules.push(group);
  }
  removeRule(index: number) {
    this.rules.removeAt(index);
    this.updateSerializedRules();
  }
  
  private loadRulesFromString(value: string) {
    this.rules.clear();
    if (!value) return;
    const rulePairs = value.split('||');
    rulePairs.forEach(pair => {
      const [pattern, replacement] = pair.split('=>');
      this.addRule(pattern, replacement);
    });
    this.updateSerializedRules();
  }
  
  updateSerializedRules() {
    this.serializedRules = this.rules.controls
      .map(c => `${c.value.pattern}=>${c.value.replacement}`)
      .join('||');
    this.rulesStringChange.emit(this.serializedRules);
  }
  
  onSubmit() {
    this.updateSerializedRules();
  }
}
